import { secureStorage } from '../utils/secureStorage';
import { BACKEND_URL } from '../utils/backendUrl';
/**
 * Product Pack V4 API Functions
 */

/**
 * Link an Ambassador Knowledge Pack to a Product Pack
 */
export const linkAmbassadorToPack = async (packId, ambassadorPackId, endorsementContext = null) => {
  const response = await fetch(
    `${BACKEND_URL}/api/v4/product-packs/${packId}/link-ambassador?ambassador_pack_id=${ambassadorPackId}${endorsementContext ? `&endorsement_context=${encodeURIComponent(endorsementContext)}` : ''}`,
    {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`,
        'Content-Type': 'application/json'
      }
    }
  );
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to link ambassador');
  }
  
  return response.json();
};

/**
 * Unlink an Ambassador from a Product Pack
 */
export const unlinkAmbassadorFromPack = async (packId, ambassadorId) => {
  const response = await fetch(
    `${BACKEND_URL}/api/v4/product-packs/${packId}/unlink-ambassador/${ambassadorId}`,
    {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
      }
    }
  );
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to unlink ambassador');
  }
  
  return response.json();
};

/**
 * Get enriched ambassadors for a product (with full Knowledge Pack data)
 */
export const getEnrichedAmbassadors = async (packId) => {
  const response = await fetch(
    `${BACKEND_URL}/api/v4/product-packs/${packId}/ambassadors-enriched`,
    {
      headers: {
        'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
      }
    }
  );
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to fetch enriched ambassadors');
  }
  
  return response.json();
};

/**
 * Fetch available Ambassador Knowledge Packs for linking
 */
export const getAvailableAmbassadorPacks = async () => {
  const response = await fetch(
    `${BACKEND_URL}/api/v3/packs?pack_type=ambassador&status=published`,
    {
      headers: {
        'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
      }
    }
  );
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to fetch ambassador packs');
  }
  
  return response.json();
};
